import dateHelper from '@utils/dates';

export const getTime = (d, type) => {
  const date = new Date(d);
  const m = type === 'hrs' ? date.getHours() : date.getMinutes();
  if (m < 10) {
    return `0${m}`;
  }
  return m;
};

export const isBeforeBreak = (d) => {
  const date = new Date(d);
  return date.getHours() < 15;
};

export const buttonTypes = {
  live: 1,
  completed: 2,
  zoom: 3
};

export const getIsLive = (scheduledClass) => {
  const {
    live_at: liveAtString,
    video_duration: lessonDuration
  } = scheduledClass;
  const today = new Date();
  return (
    dateHelper.compareDates(today, liveAtString) === -1 &&
    dateHelper.compareDates(
      today,
      dateHelper.addTime(new Date(liveAtString), lessonDuration)
    ) === 1
  );
};
